// Internal Imports
import store from "../../store";
import { API_ENDPOINTS } from "../../constants";
import { GlobalUtils, AmplitudeUtils } from "../../utils";
import {
  fetchAppConfig,
  fetchFlagConfig,
  fetchUserSignUpInfo,
} from "../CommonActions/commonService";

import { getRoleDetailsWriteToLocalStrge } from "../UserActions/userService";
import { billingBandNotifyAction } from "../SettingsActions/settingsActions";
import { post } from "../../api/index";

// Methods Imports
import { getRedirectUrlPostSignout } from "./authMethods";

// Destructuring
const { APIS } = API_ENDPOINTS;
const {
  writeDataToLocalStorage,
  removeDataFromLocalStorage,
  removeCookie,
} = GlobalUtils;
const { amplitudeInit } = AmplitudeUtils;

// Declarations

const COOKIES_DELETE_LIST = ["fromUrl", "user"];
const LOCAL_STORAGE_DELETE_LIST = [
  "appFlag",
  "appView",
  "assetCustomColumns",
  "featureEntityMap",
  "isFirstLogin",
  "revvsalesUser",
  "revvsalesUserFeatures",
  "revvsalesUserPermissions",
  "userSignUpInfo",
  "billingBandClosedDate",
  "stripeData",
  "planHash",
  "oldPlanHash",
];

/*
AuthActions don't use an external AuthServices file
The service are written below within the actions
*/

// for authenticating the user after getting user obj
export const authenticateUser = async userObject => {
  try {
    writeDataToLocalStorage("revvsalesUser", userObject);
    const userPermissions = await getRoleDetailsWriteToLocalStrge(
      userObject.roles,
    );
    const appConfig = await fetchAppConfig();
    const appFlagConfig = await fetchFlagConfig();
    const appUserSignUpInfo = await fetchUserSignUpInfo();
    const promiseArray = await Promise.all([
      userPermissions,
      appConfig,
      appFlagConfig,
      appUserSignUpInfo,
    ])
      .then(store.dispatch(billingBandNotifyAction(true)))
      .catch(error => {
        throw error;
      });
    return promiseArray;
  } catch (error) {
    console.error(`authService => authenticateUser => ${error}`);
    throw error;
  }
};

export const signOutUser = () =>
  new Promise((resolve, reject) => {
    try {
      amplitudeInit({});
    } catch (error) {
      console.error(
        `AmplitudeInit Error => authActions => signOutUser => amplitudeInit => ${error}`,
      );
    }

    function postSignOutProcess() {
      const logoutAuthUrl = getRedirectUrlPostSignout();
      COOKIES_DELETE_LIST.map(value => removeCookie(value));
      LOCAL_STORAGE_DELETE_LIST.map(value => removeDataFromLocalStorage(value));
      if (logoutAuthUrl) {
        window.location.href = logoutAuthUrl;
      } else {
        window.location.reload();
      }
    }

    post(`${APIS.AUTH}/logout`)
      .then(response => {
        postSignOutProcess();
        resolve(response);
      })
      .catch(error => {
        postSignOutProcess();
        reject(error);
      });
  });



// WEBPACK FOOTER //
// ./src/actions/AuthActions/authActions.js